import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function NotFoundPage() {
  const { user } = useAuth();
  return <main className="max-w-lg mx-auto p-6 space-y-4">
    <h1 className="text-2xl font-semibold">Page not found</h1>
    <p className="text-muted-foreground">This link may be outdated, or the page may have moved.</p>
    <Link to={user ? "/app" : "/login"} className="inline-flex min-h-11 items-center rounded-lg bg-forest-600 px-4 text-white">{user ? "Return to the app" : "Sign in"}</Link>
  </main>;
}
